import React from 'react';
import { useCartExpiration } from '../hooks/useCartExpiration.js';
import { translate } from '../utils/wp.js';

export function CountdownTimer() {
    const {state, timer} = useCartExpiration();

    if (state === 'inactive') {
        return null;
    }

    return (
        <div>
            <i className="icon-clock text-[16px] align-middle mr-2 animate-bounce"></i>
            {translate('your_booking_is_reserved')}&nbsp;
            <strong translate="no">{timer}</strong>
        </div>
    );
}
